import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { GENERAL_ENQUIRY_URL } from '../../utils/whatsapp';
import { trackAddToCart } from '../../utils/metaPixel';
export function Header() {
  return <header className="bg-navy" data-id="element-7" data-mp="1epqnsnr177xg">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3.5 sm:px-8" data-id="element-8" data-mp="1eopbkfya4fe5">
        <a href="#inicio" className="font-brand text-2xl italic tracking-tight text-ivory sm:text-3xl" aria-label="Jam Fragrances, inicio" data-id="element-9" data-mp="19r6xkb5en9za">
          Jam Fragrances
          <span className="text-lime" data-id="element-10" data-mp="hx4wrymgc9hv">.</span>
        </a>

        <nav aria-label="Navegación principal" className="flex items-center gap-4 sm:gap-6" data-id="element-11" data-mp="vro48oh96371">
          <a href="#perfumes" className="text-xs font-semibold uppercase tracking-wide text-ivory/80 transition-colors duration-200 ease-smooth hover:text-lime" data-id="element-12" data-mp="qznvq7n4a1yu">
            Perfumes
          </a>
          <a href={GENERAL_ENQUIRY_URL} target="_blank" rel="noreferrer" onClick={() => trackAddToCart({
          contentName: 'Pedido general (header)'
        })} className="flex items-center gap-2 rounded-full bg-lime px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-navy transition-colors duration-200 ease-smooth hover:bg-lime-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-13" data-mp="3ug3bw4xqt2ia">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-14" data-mp="3k307p6mvcra2" />
            Pedir por WhatsApp
          </a>
        </nav>
      </div>
    </header>;
}